import $ from "jquery";
import { initRunningLine } from "../main/utils/running-line.js";
window.jQuery = window.$ = $;
window.addEventListener("load", function () {
  var swiper = new Swiper(".swiper-banner", {
    autoplay: {
      delay: 5000,
    },
    loop: true,
    pagination: {
      el: ".swiper-banner-pagination",
    },
  });

  initRunningLine({
    rootSelector: "#nth-ms-news .line__runing",
  });
  // $(".news").each(function () {
  //   var postsTag = "#" + $(this).attr("id");
  //   $().vPortal({
  //     container: postsTag,
  //     el: {
  //       tabContainer: ".news-tabs > a",
  //       resultContainer: ".news-list",
  //       viewAll: ".viewAll",
  //     },
  //     paginationOptions: {},
  //   });
  // });
});
